import { cn } from '@/lib/cn';
import { Link } from '@tanstack/react-router';

interface BackButtonProps {
  to: string;
  className?: string;
  children: React.ReactNode;
}

const BackButton = ({ to, className, children }: BackButtonProps) => {
  return (
    <Link
      to={to}
      className={cn(
        'text-primary hover:text-secondary active:text-secondary inline-block transition-colors',
        className,
      )}
    >
      ← {children}
    </Link>
  );
};

export default BackButton;
